module.exports = __webpack_public_path__ + "img/moon-rain-snow-01.38250f4f.png";